import React from "react";
import CotizacionUbicacionPaso1 from "../../components/CotizacionHogar/CotizacionUbicacionPaso1";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { listarProvinciasHogarFetch,listarRelatividadesHogarFetch} from "../../redux/actions/aCotizacion";

class ContainerCotizacionPaso1 extends React.Component {
  constructor(props) {
    super(props);
  }

  // async componentDidMount() {
  //   await this.props.limpiarProvinciasHogar();
  //   let datosRelatividades =
  //   {
  //     "empresa":"AIGMETROPOLITANA",
  //     "ramo":"Hogar"
  //   }
  //   await this.props.listarRelatividadesHogar(datosRelatividades);
  // }

  render() {  

    return (
      <main className="bg-light">
        <div className="cr-content container-fluid">
          <div className="container-body-spaces">
            <CotizacionUbicacionPaso1/>
          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = state => ({
});

const mapDispatchToProps = dispatch => {
  return {
    limpiarProvinciasHogar: () => dispatch(listarProvinciasHogarFetch()),
    listarRelatividadesHogar: (param) => dispatch(listarRelatividadesHogarFetch(param)),
  };
};

export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(ContainerCotizacionPaso1)
);
